import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import {connect} from "react-redux";

const DatePicker=(props)=> {
            const id = "date" + props.val
            return (
                <form noValidate>
                    <TextField
                        id={id}
                        className='date-picker'
                        type="date"
                        value={props.val}
                        onChange={(e)=>props.dispatch(props.action(e.target.value))}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </form>
            );

};
const ConnectedDatePicker=connect()(DatePicker);

export default ConnectedDatePicker;